import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { show, hide } from "redux-modal";
import { ButtonClose } from "./style";
import ItemPrint from "../itemPrint";

export const useItem = (refresh) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handlerClosePopup = (popupName) => {
    dispatch(hide(popupName));
  };

  const onActionSuccess = async () => {
    if (refresh) {
      refresh();
    }
    handlerClosePopup("ModalForm");
  };

  const tagPrint = async (itemCode) => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-3">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <ItemPrint
                  itemCode={itemCode}
                  onCancel={() => handlerClosePopup("ModalForm")}
                  onSuccess={() => onActionSuccess()}
                ></ItemPrint>
              </div>
            </div>
          </>
        ),
      })
    );
  };

  return {
    tagPrint,
  };
};
